import { reducersActions } from "../actions/new-actions";

const {
    FETCH_COLLECTIONS_REQUEST,
    FETCH_COLLECTIONS_SUCCESS,
    FETCH_COLLECTIONS_FAILURE,
} = reducersActions;

const initialState = {
  loading: false,
  collections: [],
  error: null,
};

const collectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COLLECTIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_COLLECTIONS_SUCCESS:
      return { ...state, loading: false, collections: action.payload };
    case FETCH_COLLECTIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default collectionReducer;
